import { createNewsUrl } from "../constants/urls";
import { RestResponse } from "@/business/shared/commons/rest/RestResponse";
import { restClient } from "@/business/shared/commons/rest/restClient";
import { convertFormData } from "@/business/shared/commons/rest/convertToFormData";
import { getEnvVariable } from "@/business/shared/commons/envUtils/getEnvVariable";
import { NewsCreateRequest } from "../../domain/news";
import { DaccachErrorActions } from "@/business/shared/commons/DaccachError";

export const createNewsService = {
  async execute(
    token: string,
    createNewsRequest: NewsCreateRequest
  ): Promise<void> {
    const url = getEnvVariable
      .execute("VUE_APP_DACCACH_URL")
      .concat(createNewsUrl);

    const headers = {
      "web-token": token,
      Accept: "application/json",
    };

    const formData = convertFormData(createNewsRequest);

    const response: RestResponse = await restClient().sendRequest(
      url,
      "POST",
      formData,
      headers
    );

    if (!response.isSuccess) {
      const errorMessage =
        response.statusCode == 422
          ? DaccachErrorActions().extractFormError(response.content)
          : response.content;
      throw DaccachErrorActions().createError(errorMessage);
    }
  },
};
